
export default {
    name: 'historique-constantes',
    components: {},
    props: {
        historique: Object
    },
    data() {
        return {

        }
    },

    computed: {

    },

    mounted() {

    },
    
    methods: {

    }
}


